export const FETCH_SLIDES = "FETCH_SLIDES";
export const FETCH_SLIDES_SUCCESS = "FETCH_SLIDES_SUCCESS";
export const FETCH_SLIDES_FAIL = "FETCH_SLIDES_FAIL";

export const FETCH_SLIDE = "FETCH_SLIDE";
export const FETCH_SLIDE_SUCCESS = "FETCH_SLIDE_SUCCESS";
export const FETCH_SLIDE_FAIL = "FETCH_SLIDE_FAIL";

export const FETCH_SPONSORS = "FETCH_SPONSORS";
export const FETCH_SPONSORS_SUCCESS = "FETCH_SPONSORS_SUCCESS";
export const FETCH_SPONSORS_FAIL = "FETCH_SPONSORS_FAIL";
